import styled from '@emotion/styled';
import React, { Children, HTMLProps, PropsWithChildren } from 'react';
import tw from 'twin.macro';

interface ButtonProps extends HTMLProps<HTMLButtonElement> {
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  isLoading,
  disabled,
  className,
  onClick,
}) => (
  <button
    disabled={isLoading || disabled}
    css={(theme) => ({
      ...tw`disabled:bg-gray-200 disabled:text-black/40 disabled:border-transparent`,
    })}
    className={className}
    onClick={onClick}
  >
    {children}
  </button>
);

export const ButtonSecondary = styled(Button)`
  ${tw`px-4 py-2 bg-white border border-stroke dark:border-stroke-dark dark:text-content-dark dark:bg-black rounded-lg font-semibold relative overflow-hidden`}

  &::after {
    content: '';
    ${tw`block w-0 h-0 pointer-events-none rounded-full bg-transparent absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-300 ease-in-expo`}
  }

  &:hover:not(:disabled)::after {
    ${tw`w-[120%] h-auto aspect-square bg-black/10`}
  }
`;

export const ButtonPrimary = styled(Button)`
  ${tw`flex items-center px-4 py-2 bg-primary dark:bg-primary-dark text-black rounded-lg font-semibold relative overflow-hidden`}

  &::after {
    content: '';
    ${tw`block w-0 h-0 pointer-events-none rounded-full bg-transparent absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-300 ease-in-expo`}
  }

  &:hover:not(:disabled)::after {
    ${tw`w-[120%] h-auto aspect-square bg-black/10`}
  }
`;
